export interface ILoyaltyHistory {
  id: string;
  userId: string;
  firstname: string;
  lastname: string;
  email: string;
  itemFinalPrice: number;
  discountAmount: number;
  isExpired: boolean;
  expireDate: Date | null;
  numberOfPoints: number;
  chargeType: LoyaltyHistoryChargeTypes;
  dropinReservationId: string | null;
  userSubscriptionId: string | null;
  createdAt: Date;
  isFromReferral: boolean;
}

export enum LoyaltyHistoryChargeTypes {
  Deduction = "Deduction",
  Receive = "Receive",
}

export interface ILoyaltyBalance {
  userId: string;
  loyaltyPointsBalance: number;
  earliestExpireDate: null | Date;
  earliestExpirePoints: number | null;
}

export interface ILoyaltyExchange {
  id: number;
  numberOfPoints: number;
  userReceive: number;
}
